import { Box } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { progressProject } from "../../api/project";

export default function ProjectProgress({id,progress}) {
  function RectangleProject({ value, color, onClick }) {
    return (
      <Box
        position="relative"
        width="fit-content"
        alignItems="center"
        display="flex"
        justifyContent={"center"}
        mr="-10px"
        onClick={onClick}
        sx={{ cursor: "pointer" }}
      >
        <Box position="absolute" fontSize="10px">
          {value}
        </Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="94"
          height="27"
          viewBox="0 0 94 27"
          fill="none"
        >
          <path
            d="M93.5 27L16.463 27L1.18021e-06 13.5L16.463 -6.73479e-06L93.5 0L93.5 13.5L93.5 27Z"
            fill={color || "#D6DAFF"}
          />
        </svg>
      </Box>
    );
  }
  function RectangleProject2({ value, onClick, color }) {
    return (
      <Box
        position="relative"
        width="fit-content"
        alignItems="center"
        display="flex"
        justifyContent={"center"}
        mr="-10px"
        onClick={onClick}
        sx={{ cursor: "pointer" }}
      >
        <Box position="absolute" fontSize="10px">
          {value}
        </Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="94"
          height="27"
          viewBox="0 0 94 27"
          fill="none"
        >
          <path
            d="M94 27L16.963 27L0.500001 13.5L16.963 -6.73479e-06L94 0L77.5 13.5L94 27Z"
            fill={color || "#D6DAFF"}
          />
        </svg>
      </Box>
    );
  }
  function RectangleProjectEnd({ value, color, onClick }) {
    return (
      <Box
        position="relative"
        width="fit-content"
        alignItems="center"
        display="flex"
        justifyContent={"center"}
        mr="-10px"
        onClick={onClick}
        sx={{ cursor: "pointer" }}
      >
        <Box position="absolute" fontSize="10px">
          {value}
        </Box>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="91"
          height="27"
          viewBox="0 0 91 27"
          fill="none"
        >
          <path
            d="M91 27L0 27L2.36041e-06 -7.95547e-06L91 0L74.5062 13.5L91 27Z"
            fill={color || "#D6DAFF"}
          />
        </svg>
      </Box>
    );
  }
  const [value, setValue] = useState(null);
  const [color, setColor] = useState();

  useEffect(() => {
    if (value === 0) {
      setColor("#BB3354");
    }
    if (value === 1) {
      setColor("#FF0000");
    }
    if (value === 2) {
      setColor("#FF3D00");
    }
    if (value === 3) {
      setColor("#FF6B00");
    }
    if (value === 4) {
      setColor("#FFCB00");
    }
    if (value === 5) {
      setColor("#9CD326");
    }
  }, [value]);

  useEffect(()=>{
    if(value!==null){

        if(value!==progress)
        progressProject(id,value).then(()=>{}).catch(()=>{})
    }
  },[value])
  useEffect(()=>{
    setValue(progress)
  },[])

  return (
    <Box display="flex" justifyContent={"center"}>
      <RectangleProject
        onClick={() => setValue(0)}
        color={value >= 0 ? color : ""}
        value={"0%"}
      />
      <RectangleProject2
        onClick={() => setValue(1)}
        color={value >= 1 ? color : ""}
        value={"1% - 20%"}
      />
      <RectangleProject2
        onClick={() => setValue(2)}
        color={value >= 2 ? color : ""}
        value={"20% - 40%"}
      />
      <RectangleProject2
        onClick={() => setValue(3)}
        color={value >= 3 ? color : ""}
        value={"40% - 60%"}
      />
      <RectangleProject2
        onClick={() => setValue(4)}
        color={value >= 4 ? color : ""}
        value={"60% - 80%"}
      />
      <RectangleProjectEnd
        onClick={() => setValue(5)}
        color={value >= 5 ? color : ""}
        value={"80% - 100%"}
      />
    </Box>
  );
}
